import { observer } from 'mobx-react-lite'
import React from 'react'
import { Icon } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { useBroadcastDetailOneTimeContext } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/context/context'
import styles from './styles.module.scss'

export const BroadcastContactStatisticsSearch = observer(() => {
  const { search, setSearch } = useBroadcastDetailOneTimeContext()
  return (
    <div className={styles.search}>
      <Icon icon='search' fontSize={20} padding={6} color='var(--content-primary-tertiary)' />
      <TextField
        variant='integrated'
        InputProps={{
          placeholder: 'Search...',
          className: styles.searchInput,
        }}
        onChange={setSearch}
        value={search || ''}
      />
    </div>
  )
})
